export const CONTENT_ONLY_LAYOUT_TENANT_KEYS = ['cornerstone', 'go-1', 'ed-flex', 'edflex', 'sainsburys']

export const isContentOnlyTenantLayout = (tenantKey) => {
  return CONTENT_ONLY_LAYOUT_TENANT_KEYS.includes(tenantKey)
}
